module.exports = __webpack_public_path__ + "img/Flag_of_Kiribati.a14b363c.svg";